let base;
let domain = window.location.host;
let hotelType = domain.indexOf('localhost') !== -1
switch (domain) {
  case 'crm.xinjingtech.net':
    base = 'https://cloud.hotel.xinjingtech.net/#/?cookType=1' //正式crm
    break;
  case 'pre.crm.xinjngtech.com':
    base = 'https://pre.xinjngtech.com/#/?cookType=1' //预发布crm
    break;
  case 'dev.crm.xinjngtech.com':
    base = 'https://dev.xinjngtech.com/#/?cookType=1' //开发crm
    break;
  case 'test.crm.xinjngtech.com':
    base = 'https://test.xinjngtech.com/#/?cookType=1' //测试crm
    break;
  default:
    if (hotelType) {
      console.log(hotelType, 'url--------')
      base = 'https://test.xinjngtech.com/#/?cookType=1'
      //   base = 'https://dev.crm.xinjngtech.com/'
    } else {
      base = location.protocol + '//' + domain.replace('crm', 'hotel') + '/#/?cookType=1';
    }
    break;

}
export default base;



// WEBPACK FOOTER //
// ./src/api/crmGoBaseurl.js